'use client';

import type { FC } from 'react';
import { cva } from 'class-variance-authority';
import { cn } from '../../utils/cn';

interface SpinnerProps {
  size?: 's' | 'm' | 'l';
  color?: 'primary' | 'white';
  className?: string;
}

const spinnerVariants = cva(
  'rounded-full border-solid border-t-transparent border-r-transparent animate-spin-slow',
  {
    variants: {
      size: {
        s: 'size-4 border-2',
        m: 'size-6 border-3',
        l: 'size-9 border-4',
      },
      color: {
        primary: 'border-b-blue-500 border-l-blue-500',
        white: 'border-b-white border-l-white',
      },
    },
    defaultVariants: {
      size: 'm',
      color: 'primary',
    },
  },
);

export const Spinner: FC<SpinnerProps> = ({ size = 'm', color = 'primary', className }) => {
  return (
    <div className={cn('inline-flex items-center justify-center', className)}>
      <div className={spinnerVariants({ size, color })} />
    </div>
  );
};
